module.exports = __webpack_public_path__ + "img/art3.1b2f427a.png";